const getDefaultState = () => {
    return {
        isAlertActive: false,
        isConfirmActive: false,
        message: "",
        successCallback: () => {},
        failCallback: () => {}
    };
};

const state = getDefaultState();

const getters = {
    isAlertActive: state => state.isAlertActive,
    isConfirmActive: state => state.isConfirmActive,
    message: state => state.message,
    successCallback: state => state.successCallback,
    failCallback: state => state.failCallback
};

const actions = {
    async showAlert({commit}, {message, successCallback}) {
        commit("showAlert", {message, successCallback});
    },
    async showConfirm({commit}, {message, successCallback, failCallback}) {
        if (message) commit("showConfirm", {message, successCallback, failCallback});
    },
    initData({commit}) {
        commit("initData");
    }
};

const mutations = {
    showAlert(state, {message, successCallback}) {
        state.isAlertActive = true;
        state.message = message ? message : "";
        if (successCallback) state.successCallback = successCallback;
    },
    showConfirm(state, {message, successCallback, failCallback}) {
        state.isConfirmActive = true;
        state.message = message ? message : "";
        if (successCallback) state.successCallback = successCallback;
        if (failCallback) state.failCallback = failCallback;
    },
    initData(state) {
        state.isAlertActive = false;
        state.isConfirmActive = false;
        state.message = "";
        state.successCallback = () => {};
        state.failCallback = () => {};
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}